function esc(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function printInvoice(b, loyalty = null) {
  const rows = b.items
    .map(
      (it, i) =>
        `<tr><td>${i + 1}</td><td>${esc(it.name)}${it.staff_name ? ` <span style="color:#5C6A63;font-size:11px">(by ${esc(it.staff_name)})</span>` : ""}</td><td class="r">₹${it.price.toLocaleString("en-IN")}</td><td class="r">${it.qty}</td><td class="r">₹${(it.price * it.qty).toLocaleString("en-IN")}</td></tr>`
    )
    .join("");
  const html = `<!DOCTYPE html><html><head><title>Invoice ${b.invoice_no}</title>
<style>
  body{font-family:'Segoe UI',Arial,sans-serif;color:#1C1C1C;margin:0;padding:40px;font-size:14px}
  .head{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0A3F2F;padding-bottom:20px}
  h1{font-family:Georgia,serif;color:#0A3F2F;margin:0;font-size:28px}
  .sub{letter-spacing:3px;font-size:10px;color:#C5A059;text-transform:uppercase;margin-top:4px}
  .addr{font-size:11px;color:#5C6A63;margin-top:10px;line-height:1.6}
  .inv{text-align:right}
  .inv h2{margin:0;color:#0A3F2F;font-size:20px}
  .meta{margin:24px 0;display:flex;justify-content:space-between;font-size:13px}
  table{width:100%;border-collapse:collapse;margin-top:8px}
  th{background:#0A3F2F;color:#fff;text-align:left;padding:9px 12px;font-size:11px;text-transform:uppercase;letter-spacing:1px}
  td{padding:9px 12px;border-bottom:1px solid #E5E7E5}
  .r{text-align:right}
  th.r{text-align:right}
  .totals{margin-top:16px;margin-left:auto;width:280px}
  .totals div{display:flex;justify-content:space-between;padding:5px 0;font-size:13px}
  .totals .grand{border-top:2px solid #0A3F2F;font-weight:bold;font-size:16px;color:#0A3F2F;padding-top:10px;margin-top:6px}
  .badge{display:inline-block;padding:3px 12px;border-radius:12px;font-size:11px;font-weight:bold;${""}}
  .paid{background:#e6f4ea;color:#137333}.unpaid{background:#fce8e6;color:#c5221f}
  .foot{margin-top:50px;text-align:center;color:#5C6A63;font-size:11px;border-top:1px solid #E5E7E5;padding-top:16px}
</style></head><body>
<div class="head">
  <div>
    <h1>GREEN</h1>
    <div class="sub">Professionals Salon &amp; Academy</div>
    <div class="addr">Near R.K. Sweets, Jandi Mandir Rd, Ashok Nagar (Subhash Chowk),<br/>Sonipat, Haryana 131001 · +91 70567 49191</div>
  </div>
  <div class="inv">
    <h2>INVOICE</h2>
    <div style="margin-top:6px;font-weight:bold">${b.invoice_no}</div>
    <div style="color:#5C6A63;font-size:12px">${b.date}</div>
  </div>
</div>
<div class="meta">
${b.voided ? '<div style="position:fixed;top:45%;left:50%;transform:translate(-50%,-50%) rotate(-25deg);font-size:110px;color:rgba(197,34,31,0.13);font-weight:bold;letter-spacing:24px;z-index:99">VOID</div>' : ""}
  <div><strong>Billed To:</strong><br/>${esc(b.customer_name)}${b.phone ? `<br/><span style="color:#5C6A63">${esc(b.phone)}</span>` : ""}</div>
  <div style="text-align:right"><strong>Payment:</strong> ${esc(b.payment_method)}<br/><span class="badge ${b.paid ? "paid" : "unpaid"}">${b.paid ? "PAID" : "BALANCE DUE"}</span></div>
</div>
<table>
  <thead><tr><th>#</th><th>Item / Service</th><th class="r">Price</th><th class="r">Qty</th><th class="r">Amount</th></tr></thead>
  <tbody>${rows}</tbody>
</table>
<div class="totals">
  <div><span>Subtotal</span><span>₹${b.subtotal.toLocaleString("en-IN")}</span></div>
  <div><span>Discount</span><span>− ₹${b.discount.toLocaleString("en-IN")}</span></div>
  ${b.membership_discount ? `<div><span>Membership Discount</span><span>− ₹${b.membership_discount.toLocaleString("en-IN")}</span></div>` : ""}
  ${b.points_value ? `<div><span>Reward Points (${b.points_redeemed} pts)</span><span>− ₹${b.points_value.toLocaleString("en-IN")}</span></div>` : ""}
  ${b.gst_enabled ? `<div><span>GST (${b.gst_percent}%)</span><span>+ ₹${b.gst_amount.toLocaleString("en-IN")}</span></div>` : `<div><span>GST</span><span>Not applicable</span></div>`}
  <div class="grand"><span>Total</span><span>₹${b.total.toLocaleString("en-IN")}</span></div>
  ${!b.paid && (b.balance_due ?? 0) > 0 ? `<div><span>Amount Received</span><span>₹${(b.amount_paid || 0).toLocaleString("en-IN")}</span></div><div style="color:#c5221f;font-weight:bold"><span>Balance Due</span><span>₹${b.balance_due.toLocaleString("en-IN")}</span></div>${b.due_date ? `<div style="font-size:11px;color:#5C6A63"><span>Payment due by</span><span>${esc(b.due_date)}</span></div>` : ""}` : ""}
</div>
${b.points_earned || (loyalty && loyalty.points > 0) ? `<div style="margin-top:24px;background:#f4f8f6;border:1px dashed #0A3F2F;border-radius:8px;padding:12px 16px;font-size:12px;color:#0A3F2F;clear:both">
  <strong>⭐ GREEN Rewards</strong> — ${b.points_earned ? `You earned <strong>${b.points_earned} points</strong> on this bill. ` : ""}${loyalty ? `Your points balance: <strong>${loyalty.points}</strong>${loyalty.membership && loyalty.membership.active ? ` · ${esc(loyalty.membership.plan_name)} member (${loyalty.membership.discount_percent}% off till ${esc(loyalty.membership.expiry_date)})` : ""}. Redeem them on your next visit!` : "Redeem your points on your next visit!"}
</div>` : ""}
<div class="foot">Thank you for visiting GREEN Professionals Salon &amp; Academy!<br/>Open daily 10:00 AM – 8:00 PM · Follow us @green_professional_salon</div>
<script>window.onload=function(){window.print()}</script>
</body></html>`;
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) {
    alert("Please allow popups to print the invoice.");
    return;
  }
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  w.location.href = url;
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
